import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useWorkspace } from '@/hooks/useData';
import MarkLoader from '@/components/MarkLoader';

export default function ProtectedRoute({ children, requireWorkspace = true }) {
  const { session, loading } = useAuth();
  const navigate = useNavigate();
  const { workspace, loading: wsLoading } = useWorkspace();

  if (loading) {
    return <FullPageLoader text="Načítavam..." />;
  }

  if (!session) {
    // Redirect via useEffect in render path; but simplest: just navigate after first paint
    setTimeout(() => navigate('/login', { replace: true }), 0);
    return <FullPageLoader text="Presmerovávam na prihlásenie..." />;
  }

  if (requireWorkspace) {
    if (wsLoading) return <FullPageLoader text="Načítavam firmu..." />;
    if (!workspace) {
      setTimeout(() => navigate('/onboarding', { replace: true }), 0);
      return <FullPageLoader text="Pripravujem onboarding..." />;
    }
  }

  return children;
}

function FullPageLoader({ text }) {
  return (
    <div style={{
      position: 'fixed', inset: 0,
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      gap: 14, background: 'var(--bg)', color: 'var(--text-muted)',
      fontSize: 13,
    }}>
      <MarkLoader variant="pulse" size={48} />
      {text}
    </div>
  );
}
